import { render, staticRenderFns } from "./pin.vue?vue&type=template&id=8bb58a48&scoped=true&"
import script from "./pin.vue?vue&type=script&lang=js&"
export * from "./pin.vue?vue&type=script&lang=js&"
import style0 from "./pin.vue?vue&type=style&index=0&id=8bb58a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb58a48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
